import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { backendURL } from '../IPaddress';
import '../CSS/CRUDfiles.css';
import Select from '../store/ThemedSelect';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useSchoolYear } from '../store/SchoolYearCalculator';
import ErrorModalMessage from '../store/ErrorMessage';
import {
  CompactListTable,
  SchoolYearPicker,
  ExpandableRow,
  DetailGrid,
  DetailPanel,
  FormGrid,
  FormActions,
  ScheduleCardGrid,
  ScheduleCard,
  ScheduleEmptyState,
  ConfirmDeleteModal,
  FilterBar,
  SearchInput,
  FilterSelect,
  SortControl,
  ResultSummary,
  useListControls,
} from '../components/crud';

const AwardsEventUHSMTA = () => {
  const [eventsPrograms, setEventsPrograms] = useState([]);
  const [currentEventProgram, setCurrentEventProgram] = useState({
    event_template_id: null,
    name: null,
    description: '',
    location_id: null,
    coordinator_id: null,
    event_type_id: 8,
  });
  const [currentEventDate, setCurrentEventDate] = useState({
    event_dates_id: null,
    event_id: null,
    date: null,
    start_time: null,
    end_time: null,
    total_seats: null,
    sold_out: false,
  });
  const [currentStudentProfile, setCurrentStudentProfile] = useState({
    first_name: '',
    last_name: '',
    teacher_status: false,
    requires_email: false,
    email: null,
    school_id: null,
    school_year_id: null,
  });
  const [currentDatesSchool, setCurrentDatesSchool] = useState({
    event_date_id: '',
    school_id: '',
    school_year_id: '',
    number_of_students: 0,
  });
  const [eventDates, setEventDates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showModalDateEvent, setShowModalDateEvent] = useState(false);
  const { authState } = useAuth();
  const [openId, setOpenId] = useState(null);
  const navigate = useNavigate();
  const [eventTypes, setEventTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [userNames, setUsersNames] = useState([]);
  const [newDateModal, setNewDateModal] = useState(false);
  const [showEventDateModal, setShowEventDateModal] = useState(false);
  const [showDeletionError, setShowDeletionError] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [profileEvents, setProfileEvents] = useState([]);
  const [obcWorkshopTypes, setOBCWorkshopTypes] = useState([]);
  const [studentProfiles, setStudentProfiles] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState([]);
  const [displayedSelectionTeachers, setDisplayedSelectionTeachers] = useState([]);
  const [schoolYearList, setSchoolYearList] = useState([]);
  const [selectedSchoolYear, setSelectedSchoolYear] = useState();
  const { currentYear, schoolYearListParent } = useSchoolYear();
  const [schools, setSchools] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [showStudentForm, setShowStudentForm] = useState();
  const [showStudentListTable, setShowStudentListTable] = useState(false);
  const [datesSchoolList, setDatesSchoolList] = useState([]);
  const [loading, setLoading] = useState(true);
  // Per-event free-text filter over that event's date cards, keyed by event_id.
  const [dateSearchByEvent, setDateSearchByEvent] = useState({});
  // Which date cards have their linked-student name list expanded, keyed by event_dates_id.
  const [expandedDateStudents, setExpandedDateStudents] = useState({});

  useEffect(() => {
    if (!authState) {
      navigate('/login');
    }
  }, [authState, navigate]);

  useEffect(() => {
    if (currentYear && schoolYearListParent.length) {
      setSelectedSchoolYear(currentYear);
      setSchoolYearList(schoolYearListParent);
    }
  }, [currentYear, schoolYearListParent]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedSchoolYear) {
          await fetchEventsPrograms();
          await fetchEventDates();
          await fetchProfileEvents();
          await fetchProfiles();
          await fetchDatesSchool();
        }
        await fetchEventTypes();
        await fetchLocations();
        await fetchUserNames();
        await fetchOBCWorkshopTypes();
        await fetchSchools();
        await fetchDistricts();
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedSchoolYear]);

  const fetchEventsPrograms = async () => {
    try {
      const response = await fetch(`${backendURL}/api/events-programs/year/${selectedSchoolYear}`, {
        method: 'GET',
      });
      const data = await response.json();
      const filteredEvents = data.filter(event => event.event_type_id === 8);
      setEventsPrograms(filteredEvents);
    } catch {
      ErrorModalMessage('unable to fetch the program events');
    }
  };

  const fetchProfiles = async () => {
    try {
      const response = await fetch(`${backendURL}/api/profiles/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to fetch profiles');
      }
      const data = await response.json();
      const students = data.filter(profile => profile.teacher_status === false);
      setStudentProfiles(students);
    } catch {
      setErrorMessage('Failed to fetch the student profiles.');
    }
  };

  const fetchDatesSchool = async () => {
    try {
      const response = await fetch(`${backendURL}/api/dates-schools/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to retrieve date school links');
      }
      const data = await response.json();
      setDatesSchoolList(data);
    } catch {
      setErrorMessage('Failed to fetch dates and schools link list');
    }
  };

  const fetchProfileEvents = async () => {
    try {
      const response = await fetch(`${backendURL}/api/profile-events/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to fetch profile events');
      }
      const data = await response.json();
      setProfileEvents(data);
    } catch {
      console.error('Failed to fetch profile events');
    }
  };

  const fetchOBCWorkshopTypes = async () => {
    try {
      const response = await fetch(`${backendURL}/api/workshop_types`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to fetch the obc workshop types');
      }
      const data = await response.json();
      setOBCWorkshopTypes(data);
    } catch {
      console.error('Failed to fetch the obc workshop types');
    }
  };

  const fetchEventTypes = async () => {
    try {
      const response = await fetch(`${backendURL}/api/event-types`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      setEventTypes(data);
    } catch (error) {
      console.error('Error fetching the event types:', error.message);
    }
  };

  const fetchUserNames = async () => {
    try {
      const response = await fetch(`${backendURL}/api/app-users`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (!response.ok) throw new Error('Failed to fetch user data');
      setUsersNames(data);
    } catch (err) {
      console.error(err.message);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await fetch(`${backendURL}/api/locations`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      setLocations(data);
    } catch (error) {
      console.error('Error fetching locations:', error.message);
    }
  };

  const fetchEventDates = async () => {
    try {
      const response = await fetch(`${backendURL}/api/event-dates/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      const sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
      setEventDates(sortedData);
    } catch (error) {
      console.error('Error fetching event dates:', error.message);
    }
  };

  const fetchSchools = async () => {
    try {
      const response = await fetch(`${backendURL}/api/schools`);
      if (!response.ok) throw new Error('Unable to retrieve school information');
      const data = await response.json();
      setSchools(data);
    } catch (error) {
      console.error('Error fetching schools:', error.message);
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await fetch(`${backendURL}/api/districts`);
      if (!response.ok) throw new Error('Unable to retrieve districts');
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error('Error fetching districts:', error.message);
    }
  };

  const schoolOptions = useMemo(() =>
    schools.map(school => {
      const district = districts.find(d => d.district_id === school.district_id);
      const districtName = district ? district.name : 'Unknown District';
      return {
        label: `${school.name} (${districtName})`,
        value: school.school_id
      };
    }), [schools, districts]);

  const handleEventFormChange = (field, value, type = 'text') => {
    setCurrentEventProgram(currentEventProgram => ({
      ...currentEventProgram,
      [field]: type === 'number' ? parseInt(value, 10) || 0 : value,
      school_year_id: parseInt(selectedSchoolYear, 10),
    }));
  };

  const handleTeacherChange = selectedOptions => {
    setSelectedStudents(selectedOptions);
    const teacherIds = selectedOptions.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));
    setSelectedStudent(teacherIds);
  };

  const handleEventDateFormChange = event => {
    const { name, type, checked, value } = event.target;
    setCurrentEventDate(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : type === 'number' ? parseInt(value, 10) : value,
      school_year_id: parseInt(selectedSchoolYear, 10),
    }));
  };

  const handleStudentProfile = e => {
    setCurrentStudentProfile(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
      school_year_id: selectedSchoolYear
    }));
  };

  const handleDatesSchoolFormChange = e => {
    setCurrentDatesSchool(prevState => ({
      ...prevState,
      [e.target.name]: parseInt(e.target.value, 10),
      school_year_id: parseInt(selectedSchoolYear, 10),
    }));
  };

  const handleEventSubmit = async e => {
    e.preventDefault();
    const method = currentEventProgram.event_id ? 'PUT' : 'POST';
    const url = currentEventProgram.event_id ? `${backendURL}/api/events-programs/${currentEventProgram.event_id}` : `${backendURL}/api/events-programs`;
    await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(currentEventProgram),
      credentials: 'include',
    });
    setCurrentEventProgram({
      event_template_id: null,
      name: null,
      description: '',
      location_id: null,
      coordinator_id: null,
      event_type_id: 8,
    });
    setShowForm(false);
    fetchEventsPrograms();
  };

  const handleNewEventDate = eventProgramId => {
    setCurrentEventDate({
      event_dates_id: null,
      event_id: eventProgramId,
      date: null,
      start_time: null,
      end_time: null,
      total_seats: null,
      sold_out: false,
    });
    setCurrentDatesSchool({
      event_date_id: '',
      school_id: '',
      school_year_id: selectedSchoolYear,
      number_of_students: 0,
    });
    setShowEventDateModal(true);
  };

  const handleEventDateSubmit = async e => {
    e.preventDefault();
    if (!currentEventDate.date || !currentEventDate.start_time || !currentEventDate.end_time) {
      return setErrorMessage('Please include a date, start time and end time for the award');
    }
    try {
      const method = currentEventDate.event_dates_id ? 'PUT' : 'POST';
      const url = currentEventDate.event_dates_id ? `${backendURL}/api/event-dates/${currentEventDate.event_dates_id}` : `${backendURL}/api/event-dates`;
      const dateResponse = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(currentEventDate),
        credentials: 'include',
      });
      if (!dateResponse.ok) throw new Error('Failed to create event date for the related program');
      const newDateResponse = await dateResponse.json();

      if (newDateResponse && newDateResponse.event_dates_id) {
        const eventDateID = newDateResponse.event_dates_id;
        const dateProfilePayload = {
          event_id: newDateResponse.event_dates_id,
          profile_id: selectedStudent,
          school_year_id: parseInt(selectedSchoolYear, 10),
        };
        const eventDateProfileUrl = `${backendURL}/api/profile-events${currentEventDate.event_dates_id ? `/${currentEventDate.event_dates_id}` : ''}`;
        const eventDateProfile = await fetch(eventDateProfileUrl, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dateProfilePayload),
          credentials: 'include'
        });
        if (!eventDateProfile.ok) throw new Error('Failed to create event date profile for the event and program');

        if (eventDateID > 0 && (currentDatesSchool.school_id !== '' && currentDatesSchool.school_id !== undefined)) {
          const dateSchoolsPayload = {
            ...currentDatesSchool,
            event_date_id: eventDateID,
            number_of_students: parseInt(currentDatesSchool.number_of_students, 10),
            school_year_id: selectedSchoolYear
          };
          const datesSchoolUrl = `${backendURL}/api/dates-schools${currentEventDate.event_dates_id ? `/${currentEventDate.event_dates_id}` : ''}`;
          const datesSchoolResponse = await fetch(datesSchoolUrl, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dateSchoolsPayload),
            credentials: 'include'
          });
          if (!datesSchoolResponse.ok) throw new Error('Failed to create date, school, and student number link');
        }
        setCurrentEventDate({
          event_dates_id: null,
          event_id: null,
          date: null,
          start_time: null,
          end_time: null,
          total_seats: null,
          sold_out: false,
        });
        setShowEventDateModal(false);
        setShowModalDateEvent(false);
        setNewDateModal(false);
        fetchEventDates();
        fetchProfileEvents();
        fetchDatesSchool();
        setCurrentDatesSchool({
          event_date_id: '',
          school_id: '',
          school_year_id: '',
          number_of_students: 0,
        });
        setSelectedStudents([]);
        setSelectedStudent([]);
        setSelectedSchool([]);
      }
    } catch (error) {
      setErrorMessage('Failed to create or update event date');
    }
  };

  const handleStudentProfileSubmit = async e => {
    e.preventDefault();
    const method = currentStudentProfile.profile_id ? 'PUT' : 'POST';
    const url = currentStudentProfile.profile_id ? `${backendURL}/api/profiles/${currentStudentProfile.profile_id}` : `${backendURL}/api/profiles`;
    const studentProfileResponse = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(currentStudentProfile),
      credentials: 'include',
    });
    if (!studentProfileResponse.ok) {
      setErrorMessage('Failed to create student profile');
      throw new Error('Failed to create student profile');
    }
    const newStudentProfile = await studentProfileResponse.json();
    setShowStudentForm(false);
    setCurrentStudentProfile({
      first_name: '',
      last_name: '',
      teacher_status: false,
      requires_email: false,
      email: null,
      school_id: null,
    });
    setSelectedSchool(null);
    fetchProfiles();
  };

  const editEventProgram = eventProgram => {
    setCurrentEventProgram(eventProgram);
    setShowForm(true);
  };

  const editStudentProfile = profile => {
    setCurrentStudentProfile(profile);
    const schoolObj = schoolOptions.find(school => school.value === profile.school_id);
    if (schoolObj) {
      setSelectedSchool(schoolObj);
    }
    setShowStudentForm(true);
  };

  const studentOptions = useMemo(() =>
    studentProfiles.map(profile => ({
      label: `${profile.first_name} ${profile.last_name}`,
      value: profile.profile_id,
    })), [studentProfiles]);

  
  


  const getSchoolNameProfile = schoolId => {
    const schoolObj = schoolOptions.find(school => school.value === schoolId);
    return schoolObj ? <div>{schoolObj.label}</div> : null;
  };

  // Plain-data rollup per event date: attendance counts come from dates_schools
  // (what staff actually enter); linked student profiles are tracked separately
  // because profile tracking is optional and currently unused — the two figures
  // must never be summed together.
  const dateSummaries = useMemo(() => {
    const schoolNameById = new Map(schoolOptions.map(option => [option.value, option.label]));
    const map = new Map();
    eventDates.forEach(eventDate => {
      const dateId = eventDate.event_dates_id;
      const links = datesSchoolList.filter(dateSchool => dateSchool.event_date_id === dateId);
      const attendance = links.reduce((total, dateSchool) => total + (dateSchool.number_of_students || 0), 0);
      const linkSchoolIds = links
        .flatMap(dateSchool => (Array.isArray(dateSchool.school_id) ? dateSchool.school_id : [dateSchool.school_id]))
        .filter(id => id != null);
      const profileIds = profileEvents
        .filter(profileEvent => profileEvent.event_id === dateId)
        .flatMap(profileEvent => profileEvent.profile_id);
      const linkedProfiles = studentProfiles.filter(profile => profileIds.includes(profile.profile_id));
      const schoolIds = [...new Set([...linkSchoolIds, ...linkedProfiles.map(profile => profile.school_id)])];
      map.set(dateId, {
        attendance,
        schoolIds,
        schoolNames: schoolIds.map(id => schoolNameById.get(id)).filter(Boolean),
        studentNames: linkedProfiles.map(profile => `${profile.first_name} ${profile.last_name}`),
        linkedProfileCount: linkedProfiles.length,
      });
    });
    return map;
  }, [eventDates, datesSchoolList, profileEvents, studentProfiles, schoolOptions]);

  // Event-level rollup across all of the event's dates.
  const eventSummaries = useMemo(() => {
    const map = new Map();
    eventsPrograms.forEach(eventProgram => {
      const dates = eventDates.filter(eventDate => eventDate.event_id === eventProgram.event_id);
      const schools = new Set();
      let attendance = 0;
      let linkedProfiles = 0;
      const dateValues = [];
      dates.forEach(eventDate => {
        const summary = dateSummaries.get(eventDate.event_dates_id);
        if (summary) {
          attendance += summary.attendance;
          linkedProfiles += summary.linkedProfileCount;
          summary.schoolIds.forEach(id => schools.add(id));
        }
        if (eventDate.date) dateValues.push(eventDate.date);
      });
      dateValues.sort();
      map.set(eventProgram.event_id, {
        dateCount: dates.length,
        schoolCount: schools.size,
        attendance,
        linkedProfiles,
        dateRange: dateValues.length === 0
          ? 'No dates'
          : dateValues.length === 1
            ? dateValues[0]
            : `${dateValues[0]} to ${dateValues[dateValues.length - 1]}`,
      });
    });
    return map;
  }, [eventsPrograms, eventDates, dateSummaries]);

  // Attendance-only count (used by the row pill and the Students sort).
  const getNumberOfStudents = eventProgramId =>
    eventSummaries.get(eventProgramId)?.attendance ?? 0;

  const editEventDate = eventDate => {
    const eventDateTeachersObj = profileEvents.filter(eventProfile => eventProfile.event_id === eventDate.event_dates_id);
    const datesSchoolsObjs = datesSchoolList.filter(dateSchool => dateSchool.event_date_id === eventDate.event_dates_id);
    if (datesSchoolsObjs.length === 0) {
      setCurrentDatesSchool();
    } else {
      const schoolIds = datesSchoolsObjs.flatMap(schoolObj => schoolObj.school_id);
      const schoolObj = schoolOptions.find(school => school.value === schoolIds[0]);
      if (schoolObj) {
        setSelectedSchool(schoolObj);
      }
    }
    const listOfStudents = eventDateTeachersObj.flatMap(eventProfile =>
      studentOptions.filter(teacherOption => eventProfile.profile_id.includes(teacherOption.value))
    );
    if (listOfStudents.length) {
      const teacherIds = listOfStudents.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));
      setSelectedStudents(listOfStudents);
      setSelectedStudent(teacherIds);
    } else {
      setSelectedStudents([]);
      setSelectedStudent([]);
    }
    setCurrentEventDate({ ...eventDate });
    if (datesSchoolsObjs.length > 0) {
      setCurrentDatesSchool(datesSchoolsObjs[0]);
    } else {
      setCurrentDatesSchool([]);
    }
    setShowEventDateModal(true);
  };

  const handleCancel = () => {
    setCurrentEventDate({
      event_dates_id: null,
      event_id: null,
      date: null,
      start_time: null,
      end_time: null,
      total_seats: null,
      sold_out: false,
    });
    setCurrentDatesSchool({
      event_date_id: '',
      school_id: '',
      school_year_id: '',
      number_of_students: 0,
    });
    setCurrentEventProgram({
      event_template_id: null,
      name: null,
      description: '',
      location_id: null,
      coordinator_id: null,
      event_type_id: 8,
    });
    setCurrentStudentProfile({
      first_name: '',
      last_name: '',
      teacher_status: false,
      requires_email: false,
      email: null,
      school_id: null,
    });
    setShowForm(false);
    setShowEventDateModal(false);
    setShowModalDateEvent(false);
    setNewDateModal(false);
    setSelectedStudents([]);
    setSelectedStudent([]);
    setShowStudentForm(false);
    setSelectedSchool(null);
  };

  const handleShowEventForm = () => {
    setShowStudentListTable(false);
    setCurrentEventProgram({
      event_template_id: null,
      name: null,
      description: '',
      location_id: null,
      coordinator_id: null,
      event_type_id: 8,
    });
    setShowForm(!showForm);
  };

  const handleShowStudentList = () => {
    setShowStudentListTable(!showStudentListTable);
    setShowForm(false);
  };

  const deleteEventProgram = async event_id => {
    try {
      const response = await fetch(`${backendURL}/api/events-programs/${event_id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (response.ok) {
        fetchEventsPrograms();
      } else {
        throw new Error('Unable to delete the associated event');
      }
    } catch (error) {
      setShowDeletionError(true);
      console.error('Please delete associated event dates before deleting an event.');
    }
    setSelectedStudent([]);
  };

  const deleteStudentProfile = async profileId => {
    try {
      const response = await fetch(`${backendURL}/api/profiles/${profileId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!response.ok) throw new Error('Failed to delete the student profile');
      fetchProfiles();
    } catch {
      setErrorMessage('Failed to delete the student profile.');
    }
  };

  const handleDeleteEventDate = () => {
    setConfirmationMessage('Are you sure you want to delete this event date?');
    setShowConfirmationModal(true);
  };

  const handleSchoolChange = selectedOption => {
    setSelectedSchool(selectedOption);
    const schoolId = selectedOption ? parseInt(selectedOption.value, 10) : null;
    if (selectedOption && isNaN(schoolId)) {
      setErrorMessage(`Warning: could not parse school_id value "${selectedOption.value}" as an integer`);
    }
    setCurrentStudentProfile(prevProfile => ({
      ...prevProfile,
      school_id: schoolId
    }));
    const selectedSchoolObj = schools.find(school => school.school_id === schoolId);
    if (selectedSchoolObj) {
      const correspondingDistrict = districts.find(district => district.district_id === selectedSchoolObj.district_id);
      if (correspondingDistrict) {
        setSelectedDistrict(correspondingDistrict);
        setCurrentStudentProfile(prevProfile => ({
          ...prevProfile,
          district: correspondingDistrict.district_id
        }));
      }
    }
  };

  const handleDatesSchoolChange = selectedOption => {
    setSelectedSchool(selectedOption);
    const schoolId = selectedOption ? parseInt(selectedOption.value, 10) : null;
    if (selectedOption && isNaN(schoolId)) {
      setErrorMessage(`Warning: could not parse school_id value "${selectedOption.value}" as an integer`);
    }
    setCurrentDatesSchool(prevState => ({
      ...prevState,
      school_id: schoolId
    }));
    const selectedSchoolObj = schools.find(school => school.school_id === schoolId);
    if (selectedSchoolObj) {
      const correspondingDistrict = districts.find(district => district.district_id === selectedSchoolObj.district_id);
      if (correspondingDistrict) {
        setSelectedDistrict(correspondingDistrict);
      }
    }
  };

  const deleteEventDate = async eventDateId => {
    try {
      const dateSchoolResponse = await fetch(`${backendURL}/api/dates-schools/${eventDateId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      const dateProfileResponse = await fetch(`${backendURL}/api/profile-events/${eventDateId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (dateSchoolResponse.ok && dateProfileResponse.ok) {
        const response = await fetch(`${backendURL}/api/event-dates/${eventDateId}`, {
          method: 'DELETE',
          credentials: 'include'
        });
        if (response.ok) {
          setShowEventDateModal(false);
          setShowConfirmationModal(false);
          setSelectedSchool([]);
          setSelectedStudents([]);
          setSelectedStudent([]);
          fetchProfileEvents();
          fetchEventDates();
        } else {
          throw new Error('Failed to delete the event date');
        }
      }
    } catch (error) {
      console.error('Deletion failed:', error);
    }
  };

  const getEventType = workshopTypeID => {
    const workshopType = obcWorkshopTypes.find(eventType => eventType.type_id === workshopTypeID);
    return workshopType ? workshopType.name : 'Workshop type failed to load';
  };

  const getLocation = locationId => {
    const locationObj = locations.find(location => location.location_id === locationId);
    return locationObj ? locationObj.name : 'Event type failed to load';
  };

  const getCoordinatorId = userId => {
    const nameObject = userNames.find(user => user.user_id === userId);
    return nameObject ? `${nameObject.first_name} ${nameObject.last_name}` : 'Coordinator not assigned';
  };

  const formatTime = timeString => {
    if (timeString === null) return 'No time set';
    const [hours, minutes] = timeString.split(':');
    const hoursInt = parseInt(hours, 10);
    const suffix = hoursInt >= 12 ? 'PM' : 'AM';
    const formattedHours = ((hoursInt + 11) % 12 + 1);
    return `${formattedHours}:${minutes} ${suffix}`;
  };

  const handleYearChange = event => {
    setSelectedSchoolYear(event.target.value);
  };

  const schoolFilterOptions = useMemo(() =>
    schoolOptions
      .map(option => ({ value: String(option.value), label: option.label }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    [schoolOptions]);

  const {
    items: visibleEventsPrograms,
    resultCount,
    totalCount,
    isFiltered,
    search,
    filterList,
    sort,
    clear,
  } = useListControls(eventsPrograms, {
    searchFields: ['name', 'description'],
    filters: [
      {
        key: 'school',
        label: 'School',
        allOption: { value: 'all', label: 'All schools' },
        options: schoolFilterOptions,
        predicate: (eventProgram, value, ctx) => {
          const dateIds = ctx.eventDates
            .filter(eventDate => eventDate.event_id === eventProgram.event_id)
            .map(eventDate => eventDate.event_dates_id);
          if (!dateIds.length) return false;
          const inDatesSchools = ctx.datesSchoolList.some(dateSchool =>
            dateIds.includes(dateSchool.event_date_id) &&
            (Array.isArray(dateSchool.school_id)
              ? dateSchool.school_id.some(id => String(id) === value)
              : String(dateSchool.school_id) === value)
          );
          if (inDatesSchools) return true;
          const profileIds = ctx.profileEvents
            .filter(profileEvent => dateIds.includes(profileEvent.event_id))
            .flatMap(profileEvent => profileEvent.profile_id);
          return ctx.studentProfiles.some(profile =>
            profileIds.includes(profile.profile_id) && String(profile.school_id) === value
          );
        },
      },
    ],
    sortOptions: [
      {
        key: 'name',
        label: 'Name',
        accessor: (eventProgram) => eventProgram.name?.toLowerCase() ?? '',
      },
      {
        key: 'students',
        label: 'Students',
        accessor: (eventProgram, ctx) => ctx.getNumberOfStudents(eventProgram.event_id),
        type: 'number',
      },
    ],
    context: { getNumberOfStudents, eventDates, datesSchoolList, profileEvents, studentProfiles },
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  const promptDeleteEventDate = eventDate => {
    setCurrentEventDate({ ...eventDate });
    setConfirmationMessage('Are you sure you want to delete this event date?');
    setShowConfirmationModal(true);
  };

  const renderEventDatesDetail = (eventProgram) => {
    const eventSummary = eventSummaries.get(eventProgram.event_id);
    const allDates = eventDates.filter(eventDate => eventDate.event_id === eventProgram.event_id);

    // The page-level School filter cascades into the expanded event: only that
    // school's dates render while it is active.
    const schoolFilterValue = filterList.find(f => f.filterKey === 'school')?.value;
    const schoolFilterId =
      schoolFilterValue && schoolFilterValue !== 'all' ? parseInt(schoolFilterValue, 10) : null;
    const dateQuery = (dateSearchByEvent[eventProgram.event_id] || '').trim().toLowerCase();

    const dates = allDates.filter(eventDate => {
      const summary = dateSummaries.get(eventDate.event_dates_id);
      if (schoolFilterId != null && !(summary?.schoolIds ?? []).includes(schoolFilterId)) {
        return false;
      }
      if (!dateQuery) return true;
      const text = `${eventDate.date ?? ''} ${(summary?.schoolNames ?? []).join(' ')}`.toLowerCase();
      return text.includes(dateQuery);
    });

    const countsDiffer =
      eventSummary && eventSummary.linkedProfiles > 0 &&
      eventSummary.linkedProfiles !== eventSummary.attendance;

    return (
      <DetailGrid columns={1}>
        <DetailPanel title="Summary">
          <div className="d-flex flex-wrap gap-4">
            <div className="text-center">
              <div className="fw-bold fs-5">{eventSummary?.dateCount ?? 0}</div>
              <div className="text-muted small text-uppercase">Dates</div>
            </div>
            <div className="text-center">
              <div className="fw-bold fs-5">{eventSummary?.schoolCount ?? 0}</div>
              <div className="text-muted small text-uppercase">Schools</div>
            </div>
            <div className="text-center">
              <div className="fw-bold fs-5">{eventSummary?.attendance ?? 0}</div>
              <div className="text-muted small text-uppercase">Students</div>
            </div>
            {(eventSummary?.linkedProfiles ?? 0) > 0 && (
              <div className="text-center">
                <div className="fw-bold fs-5">{eventSummary.linkedProfiles}</div>
                <div className="text-muted small text-uppercase">Linked Profiles</div>
              </div>
            )}
            <div className="text-center">
              <div className="fw-bold fs-6">{eventSummary?.dateRange ?? 'No dates'}</div>
              <div className="text-muted small text-uppercase">Date Range</div>
            </div>
            {countsDiffer && (
              <div className="align-self-center">
                <span className="badge bg-warning text-dark">
                  Attendance and linked profiles disagree
                </span>
              </div>
            )}
          </div>
        </DetailPanel>
        <DetailPanel title="Dates & Attendance">
          <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
            <Button size="sm" onClick={() => handleNewEventDate(eventProgram.event_id)}>
              New Date
            </Button>
            {allDates.length > 1 && (
              <Form.Control
                size="sm"
                type="text"
                style={{ maxWidth: '16rem' }}
                placeholder="Filter dates by school or date..."
                value={dateSearchByEvent[eventProgram.event_id] || ''}
                onChange={e =>
                  setDateSearchByEvent(prev => ({
                    ...prev,
                    [eventProgram.event_id]: e.target.value,
                  }))
                }
              />
            )}
            {(schoolFilterId != null || dateQuery) && (
              <span className="text-muted small">
                Showing {dates.length} of {allDates.length} dates
              </span>
            )}
          </div>
          {allDates.length === 0 ? (
            <ScheduleEmptyState>No dates added yet.</ScheduleEmptyState>
          ) : dates.length === 0 ? (
            <ScheduleEmptyState>No dates match the current filters.</ScheduleEmptyState>
          ) : (
            <ScheduleCardGrid>
              {dates.map(eventDate => {
                const summary = dateSummaries.get(eventDate.event_dates_id) ?? {
                  attendance: 0, schoolNames: [], studentNames: [], linkedProfileCount: 0,
                };
                const dateCountsDiffer =
                  summary.linkedProfileCount > 0 &&
                  summary.linkedProfileCount !== summary.attendance;
                const schoolPreview =
                  summary.schoolNames.length === 0
                    ? 'No schools linked'
                    : summary.schoolNames.slice(0, 3).join(', ') +
                      (summary.schoolNames.length > 3 ? ', ...' : '');
                const namesOpen = expandedDateStudents[eventDate.event_dates_id];
                return (
                  <div key={eventDate.event_dates_id}>
                    <ScheduleCard
                      title={eventDate.date || 'No date set'}
                      time={`${formatTime(eventDate.start_time)} to ${formatTime(eventDate.end_time)}`}
                      status={dateCountsDiffer ? { label: 'Check counts', tone: 'sold-out' } : undefined}
                      meta={[
                        `${summary.schoolNames.length} school${summary.schoolNames.length === 1 ? '' : 's'} · ${summary.attendance} students`,
                        ...(summary.linkedProfileCount > 0
                          ? [`${summary.linkedProfileCount} linked profile${summary.linkedProfileCount === 1 ? '' : 's'}`]
                          : []),
                      ]}
                      preview={schoolPreview}
                      actionLabel="Click to edit date"
                      onClick={() => editEventDate(eventDate)}
                    />
                    <div className="d-flex justify-content-between align-items-center">
                      {summary.linkedProfileCount > 0 ? (
                        <Button
                          variant="link"
                          size="sm"
                          className="px-0"
                          onClick={() =>
                            setExpandedDateStudents(prev => ({
                              ...prev,
                              [eventDate.event_dates_id]: !prev[eventDate.event_dates_id],
                            }))
                          }
                        >
                          {namesOpen ? 'Hide students' : `Show ${summary.linkedProfileCount} students`}
                        </Button>
                      ) : (
                        <span />
                      )}
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => promptDeleteEventDate(eventDate)}
                        aria-label="Delete date"
                      >
                        <i className="bi bi-trash3"></i>
                      </Button>
                    </div>
                    {namesOpen && (
                      <ul className="small mb-0">
                        {summary.studentNames.map(name => (
                          <li key={name}>{name}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </ScheduleCardGrid>
          )}
        </DetailPanel>
      </DetailGrid>
    );
  };

  return (
    <div>
      <Button onClick={() => handleShowEventForm()} className="m-1">
        {showForm ? 'Show Awards Event List' : 'Add New Awards Event'}
      </Button>
      <Button onClick={() => setShowStudentForm(true)} className="m-1">
        Create Student Profile
      </Button>
      <Button onClick={() => handleShowStudentList()} className="m-1">
        {showStudentListTable ? 'Show Awards Event list' : 'Show Students List'}
      </Button>
      <SchoolYearPicker list={schoolYearList} selected={selectedSchoolYear} onChange={handleYearChange} />

      {showForm && !showStudentListTable ? (
        <Form onSubmit={handleEventSubmit}>
          <FormGrid>
            <Form.Group controlId="name">
              <Form.Label>Name of Event</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter event name"
                name="name"
                value={currentEventProgram.name}
                onChange={e => handleEventFormChange('name', e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="description" className="crud-form-span-full">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter event description"
                name="description"
                value={currentEventProgram.description}
                onChange={e => handleEventFormChange('description', e.target.value)}
              />
            </Form.Group>
            <FormActions>
              <Button type="submit">Submit</Button>
              <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
            </FormActions>
          </FormGrid>
        </Form>
      ) : showStudentListTable ? (
        <CompactListTable
          tableHeading="Students"
          emptyState={(
            <tr>
              <td>
                <ScheduleEmptyState>No student profiles have been added yet.</ScheduleEmptyState>
              </td>
            </tr>
          )}
        >
          {studentProfiles.map(profile => (
            <ExpandableRow
              key={profile.profile_id}
              main={{
                title: `${profile.first_name} ${profile.last_name}`,
                subtitle: <>{getSchoolNameProfile(profile.school_id)}</>,
              }}
              actions={(
                <>
                  <Button size="sm" onClick={() => editStudentProfile(profile)} aria-label="Edit student">
                    <i className="bi bi-pencil"></i>
                  </Button>
                  <Button size="sm" variant="danger" onClick={() => deleteStudentProfile(profile.profile_id)} aria-label="Delete student">
                    <i className="bi bi-trash3"></i>
                  </Button>
                </>
              )}
            />
          ))}
        </CompactListTable>
      ) : (
        <>
          <FilterBar
            summary={(
              <ResultSummary
                count={resultCount}
                total={totalCount}
                noun="awards event"
                onClear={clear}
                isFiltered={isFiltered}
              />
            )}
          >
            <SearchInput
              label="Search awards events"
              placeholder="Name or description"
              {...search}
            />
            {filterList.map(({ filterKey, ...f }) => (
              <FilterSelect key={filterKey} searchable {...f} />
            ))}
            <SortControl {...sort} />
          </FilterBar>
          <CompactListTable
            tableHeading="Awards Events"
            emptyState={(
              <tr>
                <td>
                  <ScheduleEmptyState>No awards events have been added yet.</ScheduleEmptyState>
                </td>
              </tr>
            )}
          >
            {visibleEventsPrograms.map(eventProgram => (
            <ExpandableRow
              key={eventProgram.event_id}
              isOpen={openId === eventProgram.event_id}
              onToggle={() => setOpenId(openId === eventProgram.event_id ? null : eventProgram.event_id)}
              main={{
                title: eventProgram.name,
                subtitle: eventProgram.description || 'No description provided.',
              }}
              pills={(() => {
                const summary = eventSummaries.get(eventProgram.event_id);
                return [
                  { label: `Dates: ${summary?.dateCount ?? 0}` },
                  { label: `Schools: ${summary?.schoolCount ?? 0}` },
                  { label: `Students: ${summary?.attendance ?? 0}` },
                  ...((summary?.linkedProfiles ?? 0) > 0 && summary.linkedProfiles !== summary.attendance
                    ? [{ label: 'Counts differ', variant: 'warning' }]
                    : []),
                ];
              })()}
              actions={(
                <>
                  <Button size="sm" onClick={() => editEventProgram(eventProgram)} aria-label="Edit event">
                    <i className="bi bi-pencil"></i>
                  </Button>
                  <Button size="sm" variant="danger" onClick={() => deleteEventProgram(eventProgram.event_id)} aria-label="Delete event">
                    <i className="bi bi-trash3"></i>
                  </Button>
                </>
              )}
              detail={renderEventDatesDetail(eventProgram)}
            />
            ))}
          </CompactListTable>
        </>
      )}

      <Modal show={showEventDateModal} onHide={handleCancel} size="lg">
        <Modal.Header>
          {currentEventDate.event_dates_id ? 'Edit Event Date' : 'Create New Event Date'}
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGrid>
              <Form.Group className="crud-form-span-full">
                <Form.Label>Select Student</Form.Label>
                <Select
                  isMulti
                  isSearchable
                  options={studentOptions}
                  value={selectedStudents}
                  onChange={handleTeacherChange}
                  classNamePrefix="select"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Select Date</Form.Label>
                <Form.Control
                  type="date"
                  id="date"
                  name="date"
                  value={currentEventDate.date}
                  onChange={handleEventDateFormChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Start Time</Form.Label>
                <Form.Control
                  type="time"
                  id="start_time"
                  name="start_time"
                  value={currentEventDate.start_time}
                  onChange={handleEventDateFormChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>End Time</Form.Label>
                <Form.Control
                  id="end_time"
                  value={currentEventDate.end_time}
                  type="time"
                  name="end_time"
                  onChange={handleEventDateFormChange}
                />
              </Form.Group>
              <Form.Group controlId="formSchool" className="crud-form-span-full">
                <Form.Label>School</Form.Label>
                <Select
                  isSearchable
                  options={schoolOptions}
                  value={selectedSchool}
                  onChange={handleDatesSchoolChange}
                  inputId="school_id"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Number of Students</Form.Label>
                <Form.Control
                  id="number_of_students"
                  name="number_of_students"
                  type="number"
                  value={currentDatesSchool.number_of_students}
                  onChange={handleDatesSchoolFormChange}
                />
              </Form.Group>
            </FormGrid>
          </Form>
          <Modal.Footer className="modal-footer-buttons">
            {currentEventDate.event_dates_id && (
              <Button variant="danger" onClick={handleDeleteEventDate}>
                Delete
              </Button>
            )}
            <Button onClick={handleEventDateSubmit}>
              {currentEventDate.event_dates_id ? 'Update' : 'Create'}
            </Button>
            <Button variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>

      <Modal show={showDeletionError} onHide={() => setShowDeletionError(false)}>
        <Modal.Header>Unable to process Request</Modal.Header>
        <Modal.Body>Please be sure to delete all associated dates with the event before deleting the event</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeletionError(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmDeleteModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        onConfirm={() => deleteEventDate(currentEventDate.event_dates_id)}
        title="Please Confirm!"
        bodyText={confirmationMessage}
      />

      <Modal show={showStudentForm} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Create Student Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGrid>
              <Form.Group controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter first name"
                  name="first_name"
                  value={currentStudentProfile.first_name}
                  onChange={handleStudentProfile}
                />
              </Form.Group>
              <Form.Group controlId="formLastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter last name"
                  name="last_name"
                  value={currentStudentProfile.last_name}
                  onChange={handleStudentProfile}
                />
              </Form.Group>
              <Form.Group controlId="formSchool" className="crud-form-span-full">
                <Form.Label>School</Form.Label>
                <Select
                  isSearchable
                  options={schoolOptions}
                  value={selectedSchool}
                  onChange={handleSchoolChange}
                  inputId="school_id"
                />
              </Form.Group>
            </FormGrid>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Close
          </Button>
          <Button variant="primary" onClick={handleStudentProfileSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <ErrorModalMessage errorMessage={errorMessage} clearErrorMessage={() => setErrorMessage('')} />
    </div>
  );
};

export default AwardsEventUHSMTA;
